// extracted by mini-css-extract-plugin
module.exports = {"backgroundSelector":"backgroundSelector___30aqD","simpleListOption":"simpleListOption___d-2PU","illustration":"illustration___35Mca"};